export default {
    english:{
        headline:<>Questions? We’re here with the answers and information you’re looking for.</>,
    },
    spanish:{
        headline:<>¿Tienes preguntas?
			Tenemos las respuestas y la información que buscas.</>,
    }
}
